// Debe coincidir con TIPOS_CANDIDATO y TIPOS_FIJOS del backend (db/models/candidato.js).
// El tipo del candidato es la corporación a la que aspira.
export const TIPOS_CANDIDATO = [
  { value: "alcalde", label: "Alcalde" },
  { value: "concejo", label: "Concejo" },
];

// "Votos Blanco" y "Votos Nulo": opciones fijas, no se editan ni se eliminan
export const TIPOS_FIJOS = [
  { value: "blanco", label: "Voto en blanco" },
  { value: "nulo", label: "Voto nulo" },
];

export const esOpcionFija = (candidato) => TIPOS_FIJOS.some((t) => t.value === candidato?.tipo);

// los candidatos creados antes de las corporaciones quedan sin tipo (null)
export const etiquetaTipoCandidato = (tipo) =>
  [...TIPOS_CANDIDATO, ...TIPOS_FIJOS].find((t) => t.value === tipo)?.label ?? "Sin corporación";
